module.exports = __webpack_public_path__ + "img/70-l.e1bf3d4c.png";